// eslint-disable-next-line no-prototype-builtins
export const hasLocalStorageItem = (name) => localStorage.hasOwnProperty(name);

export const getLocalStorageItem = (name, type) => {
  switch (type) {
    case 'json':
      try {
        const json = JSON.parse(localStorage.getItem(name));
        return json;
      } catch (e) {
        return null;
      }
    case 'boolean':
      return localStorage.getItem(name) === 'true';
    case 'float':
      return parseFloat(localStorage.getItem(name));
    case 'int':
      return parseInt(localStorage.getItem(name), 10);
    case 'string':
    default:
      return localStorage.getItem(name);
  }
};

export const setLocalStorageItem = (name, value, type) => {
  switch (type) {
    case 'json':
      try {
        if (value) {
          const json = JSON.stringify(value);
          localStorage.setItem(name, json);
        } else {
          localStorage.removeItem(name);
        }
      } catch (e) {
        localStorage.setItem(name, null);
      }
      break;
    case 'boolean':
    case 'float':
    case 'int':
    case 'string':
    default:
      localStorage.setItem(name, value);
  }
};
